import { adminGet, adminPut } from './useAdminCore';
function getSystemStatus(onSuccess = null) {
    adminGet("/SystemStatus", onSuccess);
}
function saveSystemStatus(status, onSuccess = null, onError = null) {
    adminPut("/SystemStatus", status, onSuccess, onError);
}
export { getSystemStatus, saveSystemStatus };
